// extracted by mini-css-extract-plugin
export var badge = "_hc-2";
export var detailsPanel = "_hc-0";
export var resultRow = "_hc-1";